import { createSlice, isAnyOf } from "@reduxjs/toolkit";
import { v4 as uuidv4 } from "uuid";
import { getSale, getSaleById, getParticularPage, getNext, getPrevious, handleSearch, createSale } from "./thunk";
import { NepaliDate } from "@zener/nepali-datepicker-react";
import { dateFormater } from "../../../../Utils/dateFormater";

const initialState = {
  sales: [],
  edit: false,
  sale: null,
  count: 0,
  pageNo: 1,
  next: null,
  previous: null,
  loading: false,
  loadingCreate: false,
  loadingUpdated: false,
  loadingSale: false,
  loadingNext: false,
  saleDetails: [
    {
      product: null,
      vendor: null,
      closingStock: "",
      description: "",
      actualQuantity: "",
      unit: "",
      altQuantity: "",
      altUnit: null,
      rate: "",
      amount: "",
      requiredDate: dateFormater(new NepaliDate().toADasDate()),
      unique: uuidv4(),
    },
  ],
  showCreateModal: false,
};

export const saleSlice = createSlice({
  name: "sale",
  initialState,
  reducers: {
    setShowCreateModal: (state, action) => {
      state.showCreateModal = action.payload;
    },
    goToPage: (state, { payload }) => {
      state.pageNo = payload;
    },
    saleDetailsUpdated: (state, action) => {
      state.saleDetails = action.payload;
    },

    clearSaleDetails: (state) => {
      state.saleDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
          unique: uuidv4(),
        },
      ];
    },
    clearAllSale: (state) => {
      state.edit = false;
      state.loading = false;
      state.loadingUpdated = false;
      state.loadingSale = false;
      state.sale = null;
      state.saleDetails = [
        {
          product: null,
          vendor: null,
          closingStock: "",
          description: "",
          actualQuantity: "",
          unit: "",
          altQuantity: "",
          altUnit: null,
          rate: "",
          amount: "",
          requiredDate: dateFormater(new NepaliDate().toADasDate()),
          unique: uuidv4(),
        },
      ];
    },
  },
  extraReducers: (builder) => {
    // getSaleById
    builder.addCase(createSale.pending, (state) => {
      state.loadingCreate = true;
    });
    builder.addCase(createSale.fulfilled, (state, action) => {
      state.loadingCreate = false;
    });
    builder.addCase(createSale.rejected, (state) => {
      state.loadingCreate = false;
    });
    builder.addCase(getSaleById.pending, (state) => {
      state.loading = true;
      state.sale = null;
    });
    builder.addCase(getSaleById.fulfilled, (state, action) => {
      state.edit = true;
      state.loading = false;
      state.sale = action.payload.data;
      state.saleDetails = action.payload.data?.saleInvoiceDetails.map((value) => {
        return { ...value, unique: uuidv4() };
      });
    });
    builder.addCase(getSaleById.rejected, (state) => {
      state.edit = false;
      state.loading = false;
      state.sale = null;
    });
    builder.addMatcher(
      isAnyOf(getSale.pending, getParticularPage.pending, getPrevious.pending, getNext.pending, handleSearch.pending),
      (state) => {
        state.loadingSale = true;
      }
    );

    builder.addMatcher(
      isAnyOf(
        getSale.fulfilled,
        getParticularPage.fulfilled,
        getPrevious.fulfilled,
        getNext.fulfilled,
        handleSearch.fulfilled
      ),
      (state, action) => {
        state.loadingSale = false;
        state.sales = action.payload.data;
        state.count = action.payload.totalCount;

        state.previous = action.payload.previous;
        state.next = action.payload.next;
      }
    );
    builder.addMatcher(
      isAnyOf(
        getSale.rejected,
        getParticularPage.rejected,
        getPrevious.rejected,
        getNext.rejected,
        handleSearch.rejected
      ),
      (state) => {
        state.loadingSale = false;
      }
    );
  },
});

export const { setShowCreateModal, goToPage, saleDetailsUpdated, clearSaleDetails, clearAllSale } = saleSlice.actions;

export default saleSlice.reducer;
